exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "blockquote[data-v-269f2d3d]{border-width:3px;font-size:1em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/FeedbackContent.vue"],"names":[],"mappings":"AACA,4BACE,iBAAkB,AAClB,aAAe,CAChB","file":"FeedbackContent.vue","sourcesContent":["\nblockquote[data-v-269f2d3d] {\n  border-width: 3px;\n  font-size: 1em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-269f2d3d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FeedbackContent.vue
// module id = 950
// module chunks = 7